import { toast } from 'react-toastify';
import store from '../store';
import { apiServices } from '../services/api.services';

export const changeActiveTab = (tab) => {
    return async (Dispatch) => {
        Dispatch({type: 'ADMIN_CHANGE_TAB', tab});
    }
}

export const searchUsersByName = (name) => {
    if (!name.length) return;
    return async (Dispatch) => {
        apiServices.post("/adminGetUsersByName", {pseudo: name}).then((res) => {
            Dispatch({type: 'ADMIN_USERS_SEARCH_LIST', list: res.data.data});
        }).catch(err => {
            return err;
        });
    }
}

export const userCheckProfile = (id) => {
    if (!id) return;
    return async (Dispatch) => {
        apiServices.post("/adminGetUser", {sid: id}).then((res) => {
            Dispatch({type: 'ADMIN_USER_SET_PROFILE', user: res.data.data});
        }).catch(err => {
            return err;
        });
    }
}

export const closeProfile = () => {
    return async (Dispatch) => {
        Dispatch({type: 'ADMIN_CLOSE_PROFILE'});
    }
}

export const refreshLogs = () => {
    toast.success('Logs refreshed with success!');
}

export const pauseLogs = () => {
    return async (Dispatch) => {
        var isPaused = store.getState().admin.logs.pause;
        if (isPaused) toast.success('Logs are now resumed!');
        else toast.success('Logs are now paused!');
        Dispatch({type: 'ADMIN_LOGS_PAUSE', pause: !isPaused});
    }
}